import axios from "./httpService";

export default {
  clinicListApi: params => axios.get("/v3/clinics", { params })
};
